import { render, staticRenderFns } from "./taskListModal.vue?vue&type=template&id=b0161c52&scoped=true"
import script from "./taskListModal.vue?vue&type=script&lang=js"
export * from "./taskListModal.vue?vue&type=script&lang=js"
import style0 from "./taskListModal.vue?vue&type=style&index=0&id=b0161c52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0161c52",
  null
  
)

export default component.exports